export default __webpack_public_path__ + "static/media/housing-corporation-icon.99781191.svg";